import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"
import $ from "jquery"

window.jQuery = $
window.$ = $

require("../field_toggle")
require("../password_validation")
require("../trip_form_validation")
require("owl.carousel")
require("owl.carousel/dist/assets/owl.carousel.css")
require("select2")
var _moment = require("moment"); var moment = _moment.default || _moment;
window.moment = moment
require("eonasdan-bootstrap-datetimepicker")
require("ion-rangeslider")
if ($.fn.ionRangeSlider && !$.fn.ionRangeSlider.__carrylugPatched) {
  var originalIonRangeSlider = $.fn.ionRangeSlider

  $.fn.ionRangeSlider = function() {
    this.each(function() {
      var existing = $(this).data("ionRangeSlider")
      if (existing && typeof existing.destroy === "function") {
        existing.destroy()
      }
    })

    return originalIonRangeSlider.apply(this, arguments)
  }

  $.fn.ionRangeSlider.__carrylugPatched = true
}
require("selectric")
require("daterangepicker")
var _iti = require("intl-tel-input"); var intlTelInput = _iti.default || _iti;
require("@nathanvda/cocoon")
require('bootstrap-tagsinput');
global.toastr = require("toastr")
window.toastr = global.toastr

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const CARRYLUG_CONFIRM_MODAL_SELECTOR = "#carrylugConfirmationModal";
let activeCarrylugConfirmation = null;

function finishCarrylugConfirmation(answer) {
  if (!activeCarrylugConfirmation) return;

  const confirmation = activeCarrylugConfirmation;
  activeCarrylugConfirmation = null;
  confirmation.resolve(answer);
}

function openCarrylugConfirmation(options) {
  const settings = typeof options === "string" ? { message: options } : (options || {});
  const $modal = $(CARRYLUG_CONFIRM_MODAL_SELECTOR);

  if (!$modal.length) {
    console.error("[confirmation] Shared confirmation modal is missing from the page layout.");
    return Promise.resolve(false);
  }

  if (activeCarrylugConfirmation) {
    finishCarrylugConfirmation(false);
  }

  $modal.find("#carrylugConfirmationModalLabel").text(settings.title || $modal.find("#carrylugConfirmationModalLabel").data("default-title") || "Confirm");
  $modal.find("#carrylugConfirmationModalMessage").text(settings.message || "");

  return new Promise(function(resolve) {
    activeCarrylugConfirmation = { resolve: resolve };
    $modal.modal({ backdrop: "static", keyboard: true, show: true });
  });
}

window.CarrylugConfirm = {
  open: openCarrylugConfirmation
};

$(document)
  .on("click.carrylugConfirmation", "#carrylugConfirmationAccept", function() {
    finishCarrylugConfirmation(true);
    $(CARRYLUG_CONFIRM_MODAL_SELECTOR).modal("hide");
  })
  .on("hidden.bs.modal.carrylugConfirmation", CARRYLUG_CONFIRM_MODAL_SELECTOR, function() {
    finishCarrylugConfirmation(false);
  });

Rails.confirm = function(message, element) {
  openCarrylugConfirmation({
    title: element && element.getAttribute("data-confirm-title"),
    message: message
  }).then(function(confirmed) {
    if (!confirmed || !element || !document.documentElement.contains(element)) return;

    const originalMessage = element.getAttribute("data-confirm");
    element.removeAttribute("data-confirm");

    try {
      if (element.tagName === "FORM") {
        if (typeof element.requestSubmit === "function") {
          element.requestSubmit();
        } else {
          element.submit();
        }
      } else {
        element.click();
      }
    } finally {
      if (originalMessage !== null) {
        element.setAttribute("data-confirm", originalMessage);
      }
    }
  });

  return false;
};

const DATATABLES_CSS_URL = "https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css";
const DATATABLES_JS_URL = "https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js";
const DATATABLE_TARGET_SELECTOR = ".datatable, .orders-table, .dashboard-table, .history-table, .admin-datatable";
const COMPANY_MESSAGE_MODAL_SELECTOR = ".company-message-modal";

function liftCompanyMessageModal(modal) {
  if (!modal || modal.parentNode === document.body) return;

  const $modal = $(modal);
  $modal.data("company-message-original-parent", modal.parentNode);
  $modal.data("company-message-original-next", modal.nextSibling);

  $("body > " + COMPANY_MESSAGE_MODAL_SELECTOR).filter(function() {
    return this.id && this.id === modal.id && this !== modal;
  }).remove();

  $modal.appendTo(document.body);
}

function restoreCompanyMessageModal(modal) {
  if (!modal || modal.parentNode !== document.body) return;

  const $modal = $(modal);
  const parent = $modal.data("company-message-original-parent");
  const next = $modal.data("company-message-original-next");

  if (!parent) return;

  if (document.documentElement.contains(parent)) {
    if (next && next.parentNode === parent) {
      parent.insertBefore(modal, next);
    } else {
      parent.appendChild(modal);
    }
  } else {
    $modal.remove();
  }
}

function ensureEasyAutocompleteLoaded() {
  if ($.fn.easyAutocomplete) return Promise.resolve();
  if (window.__easyAutocompleteReadyPromise) return window.__easyAutocompleteReadyPromise;

  window.__easyAutocompleteReadyPromise = import(
    /* webpackChunkName: "easy-autocomplete" */ "easy-autocomplete/dist/jquery.easy-autocomplete.js"
  ).catch(function(error) {
    window.__easyAutocompleteReadyPromise = null;
    throw error;
  });

  return window.__easyAutocompleteReadyPromise;
}

function initDataTableSafely(selector, options) {
  if (!$.fn.DataTable) return; // DataTables not loaded on this page (e.g. public pages)
  $(selector).each(function () {
    if ($.fn.DataTable.isDataTable(this)) return;
    $(this).DataTable(options);
  });
}

function pageNeedsDataTables() {
  return Boolean(document.querySelector(DATATABLE_TARGET_SELECTOR));
}

function destroyIonRangeSliders() {
  if (!$.fn.ionRangeSlider) return;

  $(".demo_1, .demo_2, .demo_3").each(function() {
    var existing = $(this).data("ionRangeSlider");
    if (existing && typeof existing.destroy === "function") {
      existing.destroy();
    }
  });
}

function ensureDataTablesAssetsLoaded() {
  if ($.fn.DataTable) return Promise.resolve();
  if (window.__dataTablesCdnReadyPromise) return window.__dataTablesCdnReadyPromise;

  if (!document.querySelector('link[data-datatables-cdn="true"]')) {
    var cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = DATATABLES_CSS_URL;
    cssLink.dataset.datatablesCdn = 'true';
    document.head.appendChild(cssLink);
  }

  window.__dataTablesCdnReadyPromise = new Promise(function(resolve, reject) {
    var existingScript = document.querySelector('script[data-datatables-cdn="true"]');
    if (existingScript) {
      if ($.fn.DataTable) {
        resolve();
        return;
      }

      existingScript.addEventListener('load', function() { resolve(); }, { once: true });
      existingScript.addEventListener('error', function() {
        window.__dataTablesCdnReadyPromise = null;
        reject(new Error('Failed to load DataTables script'));
      }, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.src = DATATABLES_JS_URL;
    script.defer = true;
    script.dataset.datatablesCdn = 'true';
    script.onload = function() { resolve(); };
    script.onerror = function() {
      window.__dataTablesCdnReadyPromise = null;
      reject(new Error('Failed to load DataTables script'));
    };
    document.head.appendChild(script);
  }).then(function() {
    if (!$.fn.DataTable) {
      throw new Error('DataTables script loaded but $.fn.DataTable is unavailable');
    }
  }).catch(function(error) {
    window.__dataTablesCdnReadyPromise = null;
    throw error;
  });

  return window.__dataTablesCdnReadyPromise;
}

function initPageDataTables() {
  registerDataTableTypeSorts(); // must run before any DataTable init that uses custom types
  initDataTableSafely('.orders-table', {
    rowReorder: true,
    searching: false,
    paging: false,
    order: [[2, "desc"]],
    columnDefs: [
      { targets: 2, type: 'date-dd-mmm-yyyy' }
    ]
  });

  initDataTableSafely('.dashboard-table', {
    rowReorder: true,
    searching: false,
    paging: false,
    order: [[1, "desc"]],
    columnDefs: [
      { targets: 1, type: 'date-dd-mmm-yyyy' }
    ]
  });

  initDataTableSafely('.history-table', {
    rowReorder: true,
    searching: false,
    paging: false,
    order: [[0, "desc"]]
  });
}

$(document).on('turbolinks:before-cache', function () {
  $("body > " + COMPANY_MESSAGE_MODAL_SELECTOR).each(function() {
    restoreCompanyMessageModal(this);
  });

  $('#trips-skeleton').hide();
  destroyIonRangeSliders();

  // Destroy Select2 so Turbolinks cache doesn't snapshot duplicate DOM elements
  if ($.fn.select2) {
    try { $('.select2-hidden-accessible').select2('destroy'); } catch(e) {}
  }

  // Destroy DateTimePicker instances so cached snapshot is clean
  if ($.fn.datetimepicker) {
    $('.bagDate, .bagdepartDate, .bagarriveDate, .datepicker, .departDate, .arriveDate, .dobPicker, .datetimepicker-input, .search-arrival-date, .search-departure-date, .daterange').each(function() {
      try {
        var picker = $(this).data('DateTimePicker') || $(this).data('daterangepicker');
        if (picker && typeof picker.destroy === 'function') picker.destroy();
      } catch(e) {}
    });
  }
});

$(document)
  .on("show.bs.modal.companyMessageModal", COMPANY_MESSAGE_MODAL_SELECTOR, function() {
    liftCompanyMessageModal(this);
  })
  .on("hidden.bs.modal.companyMessageModal", COMPANY_MESSAGE_MODAL_SELECTOR, function() {
    restoreCompanyMessageModal(this);
  });

// Kick off DataTables CDN fetch as early as possible.
if (pageNeedsDataTables()) {
  ensureDataTablesAssetsLoaded().catch(function(error) {
    console.error('[datatable] Early preload failed:', error);
  });
}

document.addEventListener('turbolinks:before-render', function(event) {
  var nextBody = event && event.data ? event.data.newBody : null;
  if (!nextBody || !nextBody.querySelector(DATATABLE_TARGET_SELECTOR)) return;

  ensureDataTablesAssetsLoaded().catch(function(error) {
    console.error('[datatable] Pre-render preload failed:', error);
  });
});

function destroyAllDataTables() {
  if (!$.fn.DataTable) return;
  $(DATATABLE_TARGET_SELECTOR).each(function () {
    if ($.fn.DataTable.isDataTable(this)) {
      $(this).DataTable().destroy();
    }
  });
}

function initTripLocationValidation() {
  const notify = (message) => {
    if (window.toastr && typeof window.toastr.error === 'function') {
      window.toastr.remove();
      window.toastr.error(message);
      return;
    }
    alert(message);
  };

  const clearSelect = ($select) => {
    if (!$select || !$select.length) return;
    $select.val('');
    $select.trigger($select.hasClass('select2-hidden-accessible') ? 'change.select2' : 'change');
  };

  const normalize = (value) => (value || '').toString().trim().toLowerCase();

  const validate = ($changed) => {
    const $fromCity = $('#trip_from_city_id');
    const $toCity = $('#trip_to_city_id');
    if ($fromCity.length && $toCity.length) {
      const fromId = $fromCity.val();
      const toId = $toCity.val();
      if (fromId && toId && fromId === toId) {
        notify('Departure and arrival city cannot be the same.');
        clearSelect($changed);
        return;
      }
    }

    const $fromCountry = $('#trip_departure_country');
    const $toCountry = $('#trip_arrival_country');
    if ($fromCountry.length && $toCountry.length) {
      const from = normalize($fromCountry.val());
      const to = normalize($toCountry.val());
      if (from && to && from === to) {
        notify('Departure and arrival country cannot be the same.');
        clearSelect($changed);
      }
    }
  };

  const selector = '#trip_from_city_id, #trip_to_city_id, #trip_departure_country, #trip_arrival_country';
  $(document).off('change.tripLocations', selector).on('change.tripLocations', selector, function () {
    validate($(this));
  });
}

function ensureGoogleGeoChartReady() {
  if (window.__googleGeoChartReadyPromise) return window.__googleGeoChartReadyPromise;

  window.__googleGeoChartReadyPromise = new Promise(function(resolve, reject) {
    function initializeGoogleCharts() {
      if (!window.google || !window.google.charts) return false;

      google.charts.load('current', {
        packages: ['geochart'],
        mapsApiKey: window.GOOGLE_MAPS_API_KEY || ''
      });
      google.charts.setOnLoadCallback(resolve);
      return true;
    }

    if (initializeGoogleCharts()) return;

    var existingScript = document.querySelector('script[data-google-charts-loader="true"]');
    var chartsScript = existingScript || document.createElement('script');

    if (!existingScript) {
      chartsScript.src = 'https://www.gstatic.com/charts/loader.js';
      chartsScript.async = true;
      chartsScript.dataset.googleChartsLoader = 'true';
      document.head.appendChild(chartsScript);
    }

    chartsScript.addEventListener('load', function() {
      if (initializeGoogleCharts()) return;
      window.__googleGeoChartReadyPromise = null;
      reject(new Error('Google Charts loaded but API is unavailable'));
    }, { once: true });

    chartsScript.addEventListener('error', function() {
      window.__googleGeoChartReadyPromise = null;
      reject(new Error('Failed to load Google Charts loader'));
    }, { once: true });
  }).catch(function(error) {
    window.__googleGeoChartReadyPromise = null;
    throw error;
  });

  return window.__googleGeoChartReadyPromise;
}

function initializeLandingGeoMap() {
  if (!$("#regions_div").length) return;

  var worldTripDataPromise = null;
  var usTripDataPromise = null;

  function fetchJsonWithCache(url, cacheName) {
    if (cacheName === 'world' && worldTripDataPromise) return worldTripDataPromise;
    if (cacheName === 'us' && usTripDataPromise) return usTripDataPromise;

    var requestPromise = new Promise(function(resolve, reject) {
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: resolve,
        error: function(xhr, status, error) {
          reject(error || status || 'Request failed');
        }
      });
    }).catch(function(error) {
      if (cacheName === 'world') worldTripDataPromise = null;
      if (cacheName === 'us') usTripDataPromise = null;
      throw error;
    });

    if (cacheName === 'world') worldTripDataPromise = requestPromise;
    if (cacheName === 'us') usTripDataPromise = requestPromise;
    return requestPromise;
  }

  function drawRegionsMap() {
    $("#regions_div").show();
    $("#us_regions_div").hide();
    $("#back_to_world").hide();

    Promise.all([
      ensureGoogleGeoChartReady(),
      fetchJsonWithCache('/high_voltage/pages/trip_counts_by_country', 'world')
    ]).then(function(results) {
      var trips = results[1] || [];
      var tripData = [['Country', 'Number of Trips']];
      trips.forEach(function(trip) {
        tripData.push([trip[0], trip[1]]);
      });

      var chartData = google.visualization.arrayToDataTable(tripData);
      var options = {
        colorAxis: {
          minValue: 0,
          maxValue: 1,
          colors: ['#e6e6e6', '#2f6fb2']
        },
        legend: 'none'
      };

      var chart = new google.visualization.GeoChart(document.getElementById('regions_div'));
      google.visualization.events.addListener(chart, 'regionClick', function(e) {
        if (e.region === 'US') drawUSMap();
      });
      chart.draw(chartData, options);
    }).catch(function(error) {
      console.error('[map] Failed to render world map:', error);
    });
  }

  function drawUSMap() {
    $("#regions_div").hide();
    $("#us_regions_div").show();
    $("#back_to_world").show();

    if ($("#us_regions_div").length === 0) return;

    var usStateMap = {
      "Alabama": "US-AL",
      "Alaska": "US-AK",
      "Arizona": "US-AZ",
      "Arkansas": "US-AR",
      "California": "US-CA",
      "Colorado": "US-CO",
      "Connecticut": "US-CT",
      "Delaware": "US-DE",
      "Florida": "US-FL",
      "Georgia": "US-GA",
      "Hawaii": "US-HI",
      "Idaho": "US-ID",
      "Illinois": "US-IL",
      "Indiana": "US-IN",
      "Iowa": "US-IA",
      "Kansas": "US-KS",
      "Kentucky": "US-KY",
      "Louisiana": "US-LA",
      "Maine": "US-ME",
      "Maryland": "US-MD",
      "Massachusetts": "US-MA",
      "Michigan": "US-MI",
      "Minnesota": "US-MN",
      "Mississippi": "US-MS",
      "Missouri": "US-MO",
      "Montana": "US-MT",
      "Nebraska": "US-NE",
      "Nevada": "US-NV",
      "New Hampshire": "US-NH",
      "New Jersey": "US-NJ",
      "New Mexico": "US-NM",
      "New York": "US-NY",
      "North Carolina": "US-NC",
      "North Dakota": "US-ND",
      "Ohio": "US-OH",
      "Oklahoma": "US-OK",
      "Oregon": "US-OR",
      "Pennsylvania": "US-PA",
      "Rhode Island": "US-RI",
      "South Carolina": "US-SC",
      "South Dakota": "US-SD",
      "Tennessee": "US-TN",
      "Texas": "US-TX",
      "Utah": "US-UT",
      "Vermont": "US-VT",
      "Virginia": "US-VA",
      "Washington": "US-WA",
      "West Virginia": "US-WV",
      "Wisconsin": "US-WI",
      "Wyoming": "US-WY"
    };

    Promise.all([
      ensureGoogleGeoChartReady(),
      fetchJsonWithCache('/high_voltage/pages/us_trip_counts_by_state', 'us')
    ]).then(function(results) {
      var states = results[1] || [];
      var stateData = [['State', 'Number of Trips']];

      states.forEach(function(state) {
        var code = usStateMap[state[0]];
        if (code) stateData.push([code, state[1]]);
      });

      if (stateData.length === 1) {
        drawRegionsMap();
        return;
      }

      var chartData = google.visualization.arrayToDataTable(stateData);
      var options = {
        region: 'US',
        resolution: 'provinces',
        colorAxis: {
          values: [0, 1],
          colors: ['#e6e6e6', '#2f6fb2']
        },
        legend: 'none'
      };

      var chart = new google.visualization.GeoChart(
        document.getElementById('us_regions_div')
      );

      var stateCodeToName = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      };

      google.visualization.events.addListener(chart, 'regionClick', function(e) {
        var code = e.region.replace('US-', '');
        var stateName = stateCodeToName[code];

        window.location.href =
          "/public/trips?from_city_id=&to_city_id=&state=" +
          encodeURIComponent(stateName);
      });
      chart.draw(chartData, options);
    }).catch(function(error) {
      console.error('[map] Failed to render US map:', error);
    });
  }

  // Start network work as early as possible so first paint of map is faster.
  ensureGoogleGeoChartReady();
  fetchJsonWithCache('/high_voltage/pages/trip_counts_by_country', 'world');
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function() {
      fetchJsonWithCache('/high_voltage/pages/us_trip_counts_by_state', 'us');
    });
  } else {
    setTimeout(function() {
      fetchJsonWithCache('/high_voltage/pages/us_trip_counts_by_state', 'us');
    }, 1200);
  }

  drawRegionsMap();
  $("#back_to_world").off("click.mapWorld").on("click.mapWorld", function() {
    drawRegionsMap();
  });
}

$(document).on('turbolinks:load', function () {
  if (window.Turbolinks) window.Turbolinks.clearCache();
  initDropdowns();
  initTripLocationValidation();
  initializeLandingGeoMap();
  const allRanges = document.querySelectorAll(".range-wrap");
  allRanges.forEach(wrap => {
    const range = wrap.querySelector(".range")
    const bubble = wrap.querySelector(".bubble");
    if(range && bubble) {
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
    }
  });

  if (pageNeedsDataTables()) {
    ensureDataTablesAssetsLoaded()
      .then(function() { initPageDataTables(); })
      .catch(function(error) { console.error('[datatable] Failed to initialize:', error); });
  }

  const messageForm = document.getElementById('message_form');
  const contentField = document.getElementById('message_content');
  const uploadField = document.getElementById('upload');
  const previewContainer = document.getElementById('file-preview-container');
  let pendingImageDataUrl = null;
  const imageUploadExtensions = [
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif',
    'tiff', 'tif', 'avif', 'jfif', 'raw', 'dng', 'cr2', 'nef', 'arw'
  ];
  const allowedMessageUploadMimeTypes = [
    'application/pdf',
    'text/csv',
    'application/csv',
    'application/vnd.ms-excel',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];
  const allowedMessageUploadExtensions = [
    'pdf', 'csv', 'doc', 'docx'
  ];
  function showMessageUploadError(errorMessage) {
    if (window.toastr && typeof window.toastr.error === 'function') {
      window.toastr.remove();
      window.toastr.error(errorMessage);
      return;
    }
    alert(errorMessage);
  }

  function getFileExtension(file) {
    const parts = (file.name || '').split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
  }

  function isAllowedMessageFile(file) {
    if (!file) return false;
    if (file.type.startsWith('image/')) return true;
    const ext = getFileExtension(file);
    if (imageUploadExtensions.includes(ext)) return true;
    return allowedMessageUploadMimeTypes.includes(file.type) || allowedMessageUploadExtensions.includes(ext);
  }

  if (uploadField) {
    uploadField.addEventListener('change', () => {
      previewContainer.innerHTML = '';
      previewContainer.classList.remove('d-none');
      pendingImageDataUrl = null;
      const file = uploadField.files[0];
      if (file) {
        if (!isAllowedMessageFile(file)) {
          uploadField.value = '';
          previewContainer.innerHTML = '';
          previewContainer.classList.add('d-none');
          const errorMessage = 'Only images and documents (PDF, CSV, DOC, DOCX) are allowed.';
          showMessageUploadError(errorMessage);
          return;
        }

        const fileReader = new FileReader();
        
        fileReader.onload = function(event) {
          const fileType = file.type.split('/')[0];
          const isImage = fileType === 'image' || imageUploadExtensions.includes(getFileExtension(file));
          if (isImage) {
            pendingImageDataUrl = event.target.result;
            const img = document.createElement('img');
            img.src = event.target.result;
            img.style.maxWidth = '100%';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
            previewContainer.appendChild(img);

            compressImageFile(file, 1600, 1600, 0.85).then(function(compressed) {
              if (compressed !== file) {
                var dt = new DataTransfer();
                dt.items.add(compressed);
                uploadField.files = dt.files;
              }
            });
          } else if (fileType === 'video') {
            const video = document.createElement('video');
            video.controls = true;
            video.style.maxWidth = '100%';
            video.style.height = 'auto';
            video.style.objectFit = 'contain';
            const source = document.createElement('source');
            source.src = event.target.result;
            source.type = file.type;
            video.appendChild(source);
            previewContainer.appendChild(video);
          } else {
            const fileLink = document.createElement('a');
            fileLink.href = event.target.result;
            fileLink.target = '_blank';
            fileLink.textContent = 'Preview ' + file.name;
            previewContainer.appendChild(fileLink);
          }
        };

        fileReader.readAsDataURL(file);
      }
    });
  }

  if (messageForm) {
    messageForm.onsubmit = (event) => {
      const messageContent = contentField.value.trim();
      const hasFile = uploadField.files.length > 0;
      const selectedFile = hasFile ? uploadField.files[0] : null;
      if (messageContent === '' && !hasFile) {
        contentField.style.borderColor = 'red';
        showMessageUploadError('Please enter a message or attach a file before submitting.');
        event.preventDefault();
        return false;
      } else if (selectedFile && !isAllowedMessageFile(selectedFile)) {
        const errorMessage = 'Only images and documents (PDF, CSV, DOC, DOCX) are allowed.';
        showMessageUploadError(errorMessage);
        uploadField.value = '';
        previewContainer.innerHTML = '';
        previewContainer.classList.add('d-none');
        event.preventDefault();
        return false;
      } else {
        contentField.style.borderColor = '';
      }

      if (hasFile && selectedFile && selectedFile.type.startsWith('image/') && pendingImageDataUrl) {
        const roomIdField = document.getElementById('room_id_field');
        const roomId = roomIdField ? roomIdField.value : null;
        if (roomId) {
          const roomContainer = document.getElementById(`room-${roomId}`);
          if (roomContainer) {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHour = ((hours % 12) || 12).toString().padStart(2, '0');
            const timeStr = `${displayHour}:${minutes} ${ampm}`;
            const todayStr = now.toISOString().slice(0, 10);

            const lastSenderAvatar = roomContainer.querySelector('.message-sender .message-img-holder .default-profile');
            const avatarHtml = lastSenderAvatar ? lastSenderAvatar.outerHTML : '<span class="default-profile"></span>';

            const optimisticHtml = `
              <div class="message mb-3 message-sender" id="message-optimistic" data-message-date="${todayStr}">
                <div class="align-items-end">
                  <div class="message-row d-flex flex-row-reverse w-100">
                    <div class="message-img-holder mr-0">
                      <div class="img-fluid shadow rounded-circle" style="display: inline-block;">
                        ${avatarHtml}
                      </div>
                    </div>
                    <div class="message-content-container d-flex flex-column align-items-end mr-0 message-bubble sender-bubble">
                      <div class="attachment-container" style="margin-top: 5px;">
                        <div class="img-preview-container">
                          <img class="img-preview" src="${pendingImageDataUrl}" style="display: block; opacity: 0.75;" alt="Uploading...">
                        </div>
                      </div>
                      <span class="message-time">${timeStr}</span>
                    </div>
                  </div>
                </div>
              </div>`;
            roomContainer.insertAdjacentHTML('beforeend', optimisticHtml);

            const messageBox = document.querySelector('.message-type-box');
            if (messageBox) messageBox.scrollTop = messageBox.scrollHeight;
          }
        }
        pendingImageDataUrl = null;
      }

      return true;
    };
  }
  
  if ($(".demo_1").length) {
    $(".demo_1").each(function() {
      var existing = $(this).data("ionRangeSlider");
      if (existing) existing.destroy();
    });
    $(".demo_1").ionRangeSlider({
      type: "double",
      grid: true,
      min: 0,
      max: 1000,
      from: 0,
      to: 1000
    });
  }

  if ($('.daterange').length) {
    $('.daterange').daterangepicker({
        autoUpdateInput: false,
        locale: {
            cancelLabel: 'Clear'
        }
    });

    $('.daterange').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
    });

    $('.daterange').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
    });
  }

  if ($("#leavingfrom").length || $("#goingto").length) {
    var options = {
      url: function(phrase) {
        return "/homes/suggest.json?query=" + phrase;
      },
      getValue: "name",
      list: {
        maxNumberOfElements: 500,
        onChooseEvent: function() {
          var from = $('#leavingfrom').getSelectedItemData().id;
          var to = $('#goingto').getSelectedItemData().id;
          $('#from_city_id').val(from);
          $('#to_city_id').val(to);
        }
      }
    };

    ensureEasyAutocompleteLoaded()
      .then(function() {
        if ($("#leavingfrom").length) $("#leavingfrom").easyAutocomplete(options);
        if ($("#goingto").length) $("#goingto").easyAutocomplete(options);
      })
      .catch(function(error) {
        console.error('[easy-autocomplete] Failed to load:', error);
      });
  }

  $(document)
    .off('click.genericExpandIcon')
    .on('click.genericExpandIcon', '.btn-outline-expand', function () {
      if ($(this).closest('.accordion-toggle[data-target], .dashboard-parent-table, .dashboard-accordion-table').length) return;
      $("i", this).toggleClass("fa-plus fa-minus");
    });

  $(document)
    .off('show.bs.collapse.accordionStateSync hide.bs.collapse.accordionStateSync')
    .on('show.bs.collapse.accordionStateSync hide.bs.collapse.accordionStateSync', function(event) {
      if (!event.target || !event.target.id) return;

      const targetSelector = '#' + event.target.id;
      const expanded = event.type === 'show';
      $('.accordion-toggle[data-target], .dashboard-accordion-row[data-target]').filter(function() {
        return $(this).attr('data-target') === targetSelector;
      }).toggleClass('is-expanded', expanded);
    });
  if ($('.arriveDate').length) {
    $('.arriveDate').datetimepicker({
      format: 'YYYY-MM-DD',
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }
  if ($('.departDate').length) {
    $('.departDate').datetimepicker({
      format: 'YYYY-MM-DD',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  if ($('.search-arrival-date').length) {
    $('.search-arrival-date').datetimepicker({
      format: 'YYYY-MM-DD',
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }
  if ($('.search-departure-date').length) {
    $('.search-departure-date').datetimepicker({
      format: 'YYYY-MM-DD',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  if ($('.arriveDate').length && $('.departDate').length) {
    $(".arriveDate").on("dp.change", function (e) {
      $('.departDate').data("DateTimePicker").minDate(e.date);
    });
    $(".departDate").on("dp.change", function (e) {
      $('.arriveDate').data("DateTimePicker").maxDate(e.date);
    });
  }

  if ($('.datepicker').length) {
    $('.datepicker').datetimepicker({
      format: 'DD MMMM YYYY',
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  if ($('.dobPicker').length) {
    $('.dobPicker').datetimepicker({
      format: 'DD-MM-YYYY',
      maxDate: moment(),
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  if ($('.datetimepicker-input').length) {
    $('.datetimepicker-input').datetimepicker({
      format: 'DD-MM-YYYY',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  // bag form — only initialize when bag date pickers exist on the page
  if ($('.bagDate').length) {
    $('.bagDate').datetimepicker({
      format: 'DD MMMM YYYY',
      useCurrent: false,
      minDate: moment().startOf('day'),
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }
  if ($('.bagdepartDate').length) {
    $('.bagdepartDate').datetimepicker({
      format: 'DD MMMM YYYY',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }
  if ($('.bagarriveDate').length) {
    $('.bagarriveDate').datetimepicker({
      format: 'DD MMMM YYYY',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  function applyBagFormDateConstraints() {
    const bagDateEl = $('.bagDate');
    const bagDepartEl = $('.bagdepartDate');
    const bagArriveEl = $('.bagarriveDate');

    if (!bagDateEl.length || !bagDepartEl.length || !bagArriveEl.length) return;

    const bagDatePicker = bagDateEl.data("DateTimePicker");
    const bagDepartPicker = bagDepartEl.data("DateTimePicker");
    const bagArrivePicker = bagArriveEl.data("DateTimePicker");

    if (!bagDatePicker || !bagDepartPicker || !bagArrivePicker) return;

    const today = moment().startOf('day');
    const parseFormats = ['DD MMMM YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY'];

    const normalizePickerDate = (picker, el) => {
      const current = picker.date();
      if (current && current.isValid && current.isValid()) return current;

      const raw = (el.val() || '').trim();
      if (!raw) return null;

      const parsed = moment(raw, parseFormats, true);
      if (!parsed.isValid()) return null;

      picker.date(parsed);
      return parsed;
    };

    let bagDate = normalizePickerDate(bagDatePicker, bagDateEl);
    let departDate = normalizePickerDate(bagDepartPicker, bagDepartEl);
    let arriveDate = normalizePickerDate(bagArrivePicker, bagArriveEl);

    bagDatePicker.minDate(today);
    bagDatePicker.maxDate(departDate || arriveDate || false);

    bagDepartPicker.minDate(bagDate || today);
    bagDepartPicker.maxDate(arriveDate || false);

    bagArrivePicker.minDate(departDate || bagDate || today);


    if (departDate && bagDate && bagDate.isAfter(departDate)) {
      bagDatePicker.date(departDate);
      bagDate = departDate;
    }
    if (arriveDate && departDate && departDate.isAfter(arriveDate)) {
      bagDepartPicker.date(arriveDate);
      departDate = arriveDate;
    }
    if (bagDate && departDate && departDate.isBefore(bagDate)) {
      bagDepartPicker.date(bagDate);
      departDate = bagDate;
    }
    if (departDate && arriveDate && arriveDate.isBefore(departDate)) {
      bagArrivePicker.date(departDate);
      arriveDate = departDate;
    }
  }

  $('.datetimepicker-input').on("click", function (e) {
    $(this).data("DateTimePicker").minDate(e.date);
  })

  if ($('.datetimepicker-input-rewards').length) {
    $('.datetimepicker-input-rewards').datetimepicker({
      format: 'DD-MM-YYYY',
      useCurrent: false,
      icons: {
        up: "fa fa-chevron-circle-up",
        down: "fa fa-chevron-circle-down",
        next: 'fa fa-chevron-circle-right',
        previous: 'fa fa-chevron-circle-left'
      }
    });
  }

  $('.bagDate, .bagdepartDate, .bagarriveDate')
    .off('dp.change.bag dp.show.bag blur.bag')
    .on('dp.change.bag dp.show.bag', applyBagFormDateConstraints)
    .on('blur.bag', applyBagFormDateConstraints);
  applyBagFormDateConstraints();

  $('header .navbar-nav a').off('click.headerNavActive').on('click.headerNavActive', function () {
    const $link = $(this);
    const href = $link.attr('href') || '';

    if (
      $link.attr('data-toggle') ||
      $link.attr('data-method') ||
      href === '#' ||
      href.charAt(0) === '#' ||
      $link.closest('.dropdown-menu').length
    ) {
      return;
    }

    const $navItem = $link.closest('li.nav-item');
    if (!$navItem.length) return;

    $link.closest('.navbar-nav').find('li.active').removeClass('active');
    $navItem.addClass('active');
  });

  $('#inner-menu a').on('click', function () {
    $('.navbar-nav').find('li.active').removeClass('active');
    $(this).parent('li').addClass('active');
  });

  if ($("#telephoneCountry").length > 0) {
    const input = document.querySelector("#telephoneCountry");
    intlTelInput(input, {
      preferredCountries: ['us', 'gb', 'th']
    });
  }
  $('.custom-select-dropdown').selectric();

// owl carousel
  if ($(".package-slider").length) {
    if ($.fn.owlCarousel) {
      var packageSlider = $(".package-slider");
      packageSlider.owlCarousel({
        autoplay: true,
        autoplayTimeout: 3000,
        items: 2.5,
        animateOut: 'fadeOut',
        margin: 10,
        nav: true,
        responsive:{
          0:{
              items:1,
              dots: true,
          },
          600:{
              items:2,
              dots: true,
          },
          1000:{
              items:2.3,
              nav:true,
          }
      }
      });
      packageSlider.find(".owl-prev").attr("aria-label", "Previous").text("<");
      packageSlider.find(".owl-next").attr("aria-label", "Next").text(">");
    }
    $('#trips-skeleton').fadeOut(300);
  }


  /* Second Slider JS Code*/
  var carousel = $(".client-slider");
  if (carousel.length && $.fn.owlCarousel) {
    carousel.owlCarousel({
      autoplay: true,
      autoplayTimeout: 3000,
      loop: true,
      items: 5,
      dots: false,
      nav: true,
      center: true,
      responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:1,
            nav:true
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
      }
    });
    carousel.find(".owl-prev").html('<i class="fas fa-chevron-left" aria-hidden="true"></i>');
    carousel.find(".owl-next").html('<i class="fas fa-chevron-right" aria-hidden="true"></i>');
    var total = $('.client-slider .owl-stage .owl-item.active').length;
    $('.client-slider .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');
    $('.client-slider .owl-stage .owl-item.active').each(function (index) {
      if (index === 1) {
        $(this).addClass('firstActiveItem');
      }
      if (index === total - 2 && total > 1) {

        $(this).addClass('lastActiveItem');
      }
    });
    carousel.on('translated.owl.carousel', function (event) {
      var total = $('.client-slider .owl-stage .owl-item.active').length;
      $('.client-slider .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');

      $('.client-slider .owl-stage .owl-item.active').each(function (index) {
        if (index === 1) {
          // this is the first one
          $(this).addClass('firstActiveItem');
        }
        if (index === total - 2 && total > 1) {
          // this is the last one
          $(this).addClass('lastActiveItem');
        }
      });
    });
  } // end if (carousel.length)

  function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $(window).scroll(function () {
    if ($(this).scrollTop() > 80) {
      $('.navbar').addClass('darkheader');
    } else {
      $('.navbar').removeClass('darkheader');
    }
  });

  $(document).on('click', '.searchPanel.dropdown-menu', function (e) {
    e.stopPropagation();
  });

  $(document).on('click', '.searchPanelTo.dropdown-menu', function (e) {
    e.stopPropagation();
  });

  if ($(".selectFilter").length > 0) {
    $('.selectFilter').select2({
      placeholder: "Filter",
      allowClear: true
    });
  }
  if ($(".selectSort").length > 0) {
    $('.selectSort').select2({
      placeholder: "Filter",
      allowClear: true
    });
  }

  if ($(".cityFromFilter").length > 0) {
    $('.cityFromFilter').select2({
      placeholder: "#{t('labels.select_departure_city')}",
      allowClear: true
    });
  }
  if ($(".cityToFilter").length > 0) {
    $('.cityToFilter').select2({
      placeholder: "#{t('labels.select_arrival_city')}",
      allowClear: true
    });
  }

  // Apex chart — dynamically imported so it doesn't bloat the main bundle on pages that don't need it.
  // The import() call is a webpack code-split point: it produces a separate chunk loaded on demand.
  // turbolinks:load is async-friendly — the chart renders after the chunk loads.
  if ($("#chart").length > 0) {
    import(/* webpackChunkName: "apexcharts" */ 'apexcharts').then(function(module) {
      var ApexCharts = module.default;
      window.ApexCharts = ApexCharts; // expose globally for any view-level scripts
      var options = {
        chart: {
          type: 'bar',
          width: '100%',
          height: '265px'
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            columnWidth: '25%',
            dataLabels: false
          }
        },
        fill: {
          colors: ['#2E5DAA', '#F1A000']
        },
        series: [{
          name: 'sales',
          data: [200, 400, 500, 1000, 500, 510, 100, 200, 400, 500, 1000, 1200],
          labels: false
        }],
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        }
      };
      var chart = new ApexCharts(document.querySelector("#chart"), options);
      chart.render();
    }).catch(function(err) {
      console.error('[apexcharts] Failed to load chart library:', err);
    });
  }
  document.querySelectorAll('.yt-facade').forEach(function(el) {
    el.addEventListener('click', function() {
      var id = el.dataset.videoId;
      el.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1" allowfullscreen allow="autoplay; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:6px;"></iframe>';
    });
  });

  function refreshTruncatedNameTooltips() {
    $('[data-truncated-name-tooltip="true"]').each(function () {
      var $wrapper = $(this);
      var textElement = $wrapper.find('.text-truncate').get(0);
      var $icon = $wrapper.find('.js-truncated-name-icon').first();

      if (!textElement || !$icon.length) {
        return;
      }

      var fullText = ($icon.attr('title') || $icon.attr('data-original-title') || $icon.attr('data-tooltip-text') || '').trim();
      var visibleText = (textElement.textContent || '').trim();
      var isShortened = fullText.length > 0 && visibleText !== fullText;
      var isOverflowing = textElement.scrollWidth > textElement.clientWidth + 1;
      var shouldShowIcon = isShortened || isOverflowing;

      $icon.toggleClass('d-none', !shouldShowIcon);
      $icon.toggleClass('d-inline-flex', shouldShowIcon);
    });
  }

  window.refreshTruncatedNameTooltips = refreshTruncatedNameTooltips;
  refreshTruncatedNameTooltips();

  if ($.fn.tooltip) {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover focus'
    });
  }

  $(window).off('resize.truncatedNameTooltips').on('resize.truncatedNameTooltips', function () {
    window.requestAnimationFrame(refreshTruncatedNameTooltips);
  });

  $(document).off('shown.bs.collapse.truncatedNameTooltips').on('shown.bs.collapse.truncatedNameTooltips', function () {
    window.requestAnimationFrame(refreshTruncatedNameTooltips);
  });

  var lastMobileTooltipTouchAt = 0;

  $(document).off('click.mobileTooltip touchend.mobileTooltip', '[data-toggle="tooltip"]').on('click.mobileTooltip touchend.mobileTooltip', '[data-toggle="tooltip"]', function (event) {
    var isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) {
      return;
    }

    if (event.type === 'click' && Date.now() - lastMobileTooltipTouchAt < 700) {
      return;
    }

    if (event.type === 'touchend') {
      lastMobileTooltipTouchAt = Date.now();
    }

    event.preventDefault();
    event.stopPropagation();

    var $tooltipTrigger = $(this);
    var isVisible = $tooltipTrigger.attr('aria-describedby');

    if ($.fn.tooltip) {
      $('[data-toggle="tooltip"]').not($tooltipTrigger).tooltip('hide');
      $tooltipTrigger.tooltip(isVisible ? 'hide' : 'show');
    }
  });

  $(document).on('click touchstart', function (event) {
    var isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) {
      return;
    }

    if ($(event.target).closest('[data-toggle="tooltip"]').length === 0) {
      if ($.fn.tooltip) {
        $('[data-toggle="tooltip"]').tooltip('hide');
      }
    }
  });
});

$(document).on('turbolinks:before-cache', function () {
  destroyAllDataTables();
  if ($("#regions_div").length) {
    $("#regions_div").empty().hide();
    $("#us_regions_div").empty().hide();
    $("#back_to_world").hide();
  }
});

function purchaseWeightMessage($field) {
  return $field.data('weight-error-message') || 'Product weight exceeds the trip remaining weight.';
}

function showPurchaseWeightError($field, message) {
  $field.addClass('is-invalid').css("border", "1px solid red");

  var $error = $field.siblings('.purchase-weight-error').first();
  if (!$error.length) {
    $error = $field.closest('.form-group, .mb-3, .purchase-weight-row').find('.purchase-weight-error').first();
  }

  if ($error.length) {
    $error.text(message);
  }

  if (window.toastr && typeof window.toastr.error === 'function') {
    window.toastr.remove();
    window.toastr.error(message);
  }
}

function clearPurchaseWeightError($field) {
  $field.removeClass('is-invalid').css("border", "");

  var $error = $field.siblings('.purchase-weight-error').first();
  if (!$error.length) {
    $error = $field.closest('.form-group, .mb-3, .purchase-weight-row').find('.purchase-weight-error').first();
  }

  if ($error.length) {
    $error.text('');
  }
}

window.validatePurchaseWeightInput = function(field) {
  var $field = $(field);
  var maxWeight = parseFloat($field.data('max-weight'));
  var value = parseFloat($field.val());

  if (Number.isNaN(maxWeight) || Number.isNaN(value)) {
    clearPurchaseWeightError($field);
    return true;
  }

  if (value > maxWeight) {
    showPurchaseWeightError($field, purchaseWeightMessage($field));
    return false;
  }

  clearPurchaseWeightError($field);
  return true;
};

$(document).on('input', '.js-purchase-weight-input, .purchase-weight-input', function() {
  window.validatePurchaseWeightInput(this);
});

$(document).on('submit', 'form', function(event) {
  var isValid = true;
  $(this).find('.js-purchase-weight-input').each(function() {
    if (!window.validatePurchaseWeightInput(this)) {
      isValid = false;
    }
  });

  if (!isValid) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

function normalizedProductWeightInputValue(value) {
  var valueParts = String(value || '').replace(/,/g, '.').replace(/[^\d.]/g, '').split('.');
  var wholeNumber = valueParts.shift() || '';
  var decimalNumber = valueParts.join('').slice(0, 2);

  if (String(value || '').indexOf('.') !== -1) {
    return wholeNumber + '.' + decimalNumber;
  }

  return wholeNumber;
}

function productWeightTotalErrorMessage($form, maxWeight, productWeight) {
  var template = $form.attr('data-total-weight-error-message-template') || $form.data('weight-error-message') || 'Product weight exceeds the trip remaining weight.';

  return template
    .replace('__REMAINING_WEIGHT__', formatProductWeightNumber(maxWeight))
    .replace('__PRODUCT_WEIGHT__', formatProductWeightNumber(productWeight));
}

function productWeightConfirmTotal($form) {
  var totalWeight = 0;
  $form.find('.js-product-weight-confirm-input').each(function() {
    var value = parseFloat(normalizedProductWeightInputValue($(this).val()));
    if (!Number.isNaN(value)) {
      totalWeight += value;
    }
  });

  return totalWeight;
}

function showProductWeightTotalError($form, showToast) {
  var maxWeight = parseFloat($form.data('max-weight'));
  if (Number.isNaN(maxWeight)) return false;

  var totalWeight = productWeightConfirmTotal($form);
  if (totalWeight <= maxWeight) return false;

  var message = productWeightTotalErrorMessage($form, maxWeight, totalWeight);
  $form.find('.purchase-weight-error').text(message);
  if (showToast && window.toastr && typeof window.toastr.error === 'function') {
    window.toastr.remove();
    window.toastr.error(message);
  }

  return true;
}

$(document).on('submit', '.js-product-weight-confirm-form', function(event) {
  var $form = $(this);

  var hasInvalidWeight = false;
  $form.find('.js-product-weight-confirm-input').each(function() {
    var $input = $(this);
    var rawValue = normalizedProductWeightInputValue($.trim($input.val()));
    $input.val(rawValue);
    if (rawValue && !/^\d+(\.\d{1,2})?$/.test(rawValue)) {
      hasInvalidWeight = true;
      $input.addClass('is-invalid').css("border", "1px solid red");
      return;
    }

    $input.removeClass('is-invalid').css("border", "");
  });

  if (hasInvalidWeight) {
    var invalidMessage = $form.find('.js-product-weight-confirm-input').first().data('invalid-weight-message') || 'Weight must be a non-negative number with up to 2 decimal places.';
    $form.find('.purchase-weight-error').text(invalidMessage);
    if (window.toastr && typeof window.toastr.error === 'function') {
      window.toastr.remove();
      window.toastr.error(invalidMessage);
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  if (showProductWeightTotalError($form, true)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

function formatProductWeightNumber(value) {
  if (Number.isNaN(value)) return '';

  return value.toFixed(2).replace(/\.?0+$/, '');
}

function formatProductWeightCurrency(value, currencySymbol) {
  return (currencySymbol || '') + Number(value || 0).toFixed(2);
}

function updateProductWeightCostMessage(field) {
  var $field = $(field);
  var $message = $field.closest('.form-group').find('.js-product-weight-cost-message').first();
  if (!$message.length) return;

  var rawValue = $.trim($field.val());
  if (!/^\d+(\.\d{1,2})?$/.test(rawValue)) {
    $message.text('');
    return;
  }

  var weight = parseFloat(rawValue);
  var pricePerKg = parseFloat($field.attr('data-price-per-kg'));
  if (Number.isNaN(weight) || Number.isNaN(pricePerKg)) {
    $message.text('');
    return;
  }

  var currencySymbol = $field.attr('data-currency-symbol') || '';
  var template = $field.attr('data-calculation-message-template') || '';
  var cost = weight * pricePerKg;
  $message.text(
    template
      .replace('__PRICE_PER_KG__', formatProductWeightCurrency(pricePerKg, currencySymbol))
      .replace('__WEIGHT__', formatProductWeightNumber(weight))
      .replace('__COST__', formatProductWeightCurrency(cost, currencySymbol))
  );
}

$(document).on('input', '.js-product-weight-confirm-input', function() {
  var normalizedValue = normalizedProductWeightInputValue($(this).val());
  if ($(this).val() !== normalizedValue) {
    $(this).val(normalizedValue);
  }

  var $form = $(this).closest('.js-product-weight-confirm-form');
  $(this).removeClass('is-invalid').css("border", "");
  $form.find('.purchase-weight-error').text('');
  updateProductWeightCostMessage(this);
  showProductWeightTotalError($form, false);
});

$(document).on('turbolinks:load shown.bs.modal', function() {
  $('.js-product-weight-confirm-input').each(function() {
    updateProductWeightCostMessage(this);
  });
});

// Trip discount, currency and currency conversion rate
$(document).on("change", "[name='trip[currency]']", function() {
  var conversionRate;
  if($("[name='trip[exchange_rate]']").val()) {
    conversionRate = $("[name='trip[exchange_rate]']").val();
  } else {
    conversionRate = 1
  }

  var currencyUnit;
  if($("[name='trip[currency]'] option:selected").val()) {
    currencyUnit = $("[name='trip[currency]'] option:selected").val()
  } else {
    currencyUnit = "USD"
  }
  $(".per-kg-usd").each(function() {
    var conversionInThb = $(this).val() * conversionRate
    $(this).parents(".justify-content-between").find(".per-kg-thb").val(conversionInThb.toFixed(2) + " " + currencyUnit)
  })
});
$(document).on("keyup", ".per-kg-usd", function(event) {
  var conversionRate;
  if($("[name='trip[exchange_rate]']").val()) {
    conversionRate = $("[name='trip[exchange_rate]']").val();
  } else {
    conversionRate = 1
  }
  var currencyUnit;
  if($("[name='trip[currency]'] option:selected").val()) {
    currencyUnit = $("[name='trip[currency]'] option:selected").val()
  } else {
    currencyUnit = "USD"
  }
  var conversionInThb = event.target.value * conversionRate
  $(event.target).parents(".justify-content-between").find(".per-kg-thb").val(conversionInThb.toFixed(2) + " " + currencyUnit)
});
$(document).on("keyup", "[name='trip[exchange_rate]']", function(event) {
  var conversionRate;
  if($("[name='trip[exchange_rate]']").val()) {
    conversionRate = $("[name='trip[exchange_rate]']").val();
  } else {
    conversionRate = 1
  }
  var currencyUnit;
  if($("[name='trip[currency]'] option:selected").val()) {
    currencyUnit = $("[name='trip[currency]'] option:selected").val()
  } else {
    currencyUnit = "USD"
  }

  $(".per-kg-usd").each(function() {
    var conversionInThb = $(this).val() * conversionRate
    $(this).parents(".justify-content-between").find(".per-kg-thb").val(conversionInThb.toFixed(2) + " " + currencyUnit)
  })
})

//  Plus minus changes

$(document).on('click', ".minus", function() {
  let itemPrice = $(this).data('item-price');
  let priceDiv = $(this).data("price-item");
  let itemDiv = $(this).data("item-div");
  $(this).parents(".input-group").find("input[type='number']").val(function(i, value) {
    let beforeValue = +value;
    if( beforeValue < 1 ){
      var newVal = 0;
    }else{
      var newVal = --value;
    }
    var newPrice = itemPrice * newVal
    $(priceDiv).html(newPrice)
    if(itemDiv == "items"){
      let inputFieldVal = $('.total-item-weight').html();
      if (inputFieldVal != 0 && newVal >= 0 ){
        if(beforeValue>0 && beforeValue<1){
          $('.total-item-weight').html(inputFieldVal-beforeValue);
        }else{
          $('.total-item-weight').html(inputFieldVal-1);
        }
      } else if (inputFieldVal == 0) {
        $('.total-item-weight').html(0);
      }
    }
    if(newVal > 0) {
      return Math.abs(newVal)
    } else {
      return ""
    }
  });
});

$(document).on('focusin', "input[data-max-quantity]", function() {
  $(this).data('previous-value', $(this).val());
});

$(document).on('input', "input[data-max-quantity]", function() {
  let maxQuantity = parseFloat($(this).attr('max'));
  let value = parseFloat($(this).val());

  if (!Number.isNaN(maxQuantity) && !Number.isNaN(value) && value > maxQuantity) {
    $(this).val($(this).data('previous-value') || '');
    toastr.remove();
    toastr.error(`Quantity cannot be more than ${maxQuantity}.`);
    return;
  }

  if ($(this).val() === '' || !Number.isNaN(value)) {
    $(this).data('previous-value', $(this).val());
  }
});

$(document).on('click', ".plus", function() {
  let itemPrice = $(this).data('item-price');
  let priceDiv = $(this).data("price-item");
  let itemDiv = $(this).data("item-div");
  let totalWeight = +$('.total-item-weight').data("total-weight");
  toastr.remove();
  $(this).parents(".input-group").find("input[type='number']").val(function(i, value) {
    let currentValue = parseFloat(value) || 0;
    let maxQuantity = parseFloat($(this).attr('max'));
    var newVal = currentValue + 1;

    if (!Number.isNaN(maxQuantity) && newVal > maxQuantity) {
      toastr.error(`Quantity cannot be more than ${maxQuantity}.`);
      return Math.abs(currentValue);
    }

    var newPrice = itemPrice * newVal
    $(priceDiv).html(newPrice)
    let inputFieldVal = $('.total-item-weight').html();
    if((itemDiv == "items") && (inputFieldVal <= totalWeight)){
      ++inputFieldVal;
    }

    if (newVal > 0) {
      if ((itemDiv == "items") && (inputFieldVal > totalWeight)) {
        toastr.error(`Total Available weight is ${totalWeight}kg. You can't add more than this.`);
        setTimeout(function () {
          $('#total-weight-error').text("");
        }, 3000);
        return Math.abs(newVal-1);
      } else {
        $('.total-item-weight').html(inputFieldVal);
        $('#total-weight-error').text(""); 
        return Math.abs(newVal);
      }
    } else {
      return 0
    }
  });
});

window.setBubble = function(range, bubble) {
  const val = range.value;
  const min = range.min ? range.min : 0;
  const max = range.max ? range.max : 100;
  const newVal = Number(((val - min) * 100) / (max - min));
  bubble.innerHTML = val;
  // Sorta magic numbers based on size of the native UI thumb
  bubble.style.left = `calc(${newVal}% + (${6 - newVal * 0.15}px))`;
}

$(document).on('click', ".cancel_btn_flash", function() {
  $(".hide_flash_section").hide();
});

$(window).on('resize', function(){
  if (window.innerWidth < 769) {
    // location.reload();
    $('.per-kg-thb').addClass("text-center");
  }else{
    $('.per-kg-thb').removeClass("text-center");
  }
});

// DataTables custom type-sort plugin — must register AFTER DataTables is available.
// Moved out of module-level scope (where DataTables CDN is not yet loaded) into a
// function called from turbolinks:load, which fires after all deferred scripts finish.
function registerDataTableTypeSorts() {
  if (!$.fn.dataTable) return;
  if ($.fn.dataTable.ext.type.order['date-dd-mmm-yyyy-pre']) return; // already registered

  $.fn.dataTable.ext.type.order['date-dd-mmm-yyyy-pre'] = function(date) {
    var parts = date.split(' ');
    var day = parseInt(parts[0], 10);
    var month = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
    }[parts[1]];
    var year = parseInt(parts[2], 10);
    return new Date(year, month, day).getTime();
  };
}

$(document).on('click','.image-preview', function(){
  let modalId = $(this).data("modal-id");
  $("#"+modalId).modal("show");
})

$(document).on('select2:open', () => {
  $('.select2-search__field')[0].focus();
});

$(document)
  .on('click', '.package-image-btn', function(e) {
    var $btn = $(this);
    if ($btn.data('uploading')) {
      e.preventDefault();
      return false;
    }
    $btn.data('uploading', true);
    $btn.css('pointer-events', 'none');
    $btn.find('i').removeClass('fa-check').addClass('fa-spinner fa-spin');
  })
  .on('submit', '.package-image-form', function() {
    window.currentPackageImageForm = this;
    var $button = $(this).find('.package-image-btn');
    if (!$button.length) return true;
    if (!$button.data('uploading')) {
      $button.data('uploading', true);
      $button.css('pointer-events', 'none');
      $button.find('i').removeClass('fa-check').addClass('fa-spinner fa-spin');
    }
  })
  .on('ajax:complete', '.package-image-form', function() {
    var $button = $(this).find('.package-image-btn');
    if (!$button.length) return;
    $button.find('i').removeClass('fa-spinner fa-spin').addClass('fa-check');
    $button.css('pointer-events', '').data('uploading', false);
  })
  .on('ajax:error', '.package-image-form', function() {
    var $button = $(this).find('.package-image-btn');
    if (!$button.length) return;
    $button.find('i').removeClass('fa-spinner fa-spin').addClass('fa-check');
    $button.removeClass('d-none').css('pointer-events', '').data('uploading', false);
    if (window.toastr) toastr.error('Upload failed. Please try again.');
  });

function compressImageFile(file, maxWidth, maxHeight, quality) {
  maxWidth = maxWidth || 1600;
  maxHeight = maxHeight || 1600;
  quality = quality || 0.85;

  return new Promise(function(resolve) {
    var reader = new FileReader();
    reader.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var w = img.width;
        var h = img.height;

        if (w <= maxWidth && h <= maxHeight && file.size < 600 * 1024) {
          resolve(file);
          return;
        }

        if (w > h) {
          if (w > maxWidth) { h = Math.round(h * maxWidth / w); w = maxWidth; }
        } else {
          if (h > maxHeight) { w = Math.round(w * maxHeight / h); h = maxHeight; }
        }

        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);

        var outType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
        var outQuality = outType === 'image/png' ? undefined : quality;

        canvas.toBlob(function(blob) {
          if (!blob || blob.size >= file.size) { resolve(file); return; }
          var ext = outType === 'image/png' ? '.png' : '.jpg';
          var name = file.name.replace(/\.[^.]+$/, ext);
          resolve(new File([blob], name, { type: outType, lastModified: Date.now() }));
        }, outType, outQuality);
      };
      img.onerror = function() { resolve(file); };
      img.src = e.target.result;
    };
    reader.onerror = function() { resolve(file); };
    reader.readAsDataURL(file);
  });
}

function setFilesOnInput(input, files) {
  var dataTransfer = new DataTransfer();
  files.forEach(function(file) {
    dataTransfer.items.add(file);
  });
  input.files = dataTransfer.files;
}

function setPurchaseUploadControls(parentDiv, hasFiles, maxExceeded, maxFiles) {
  if (maxExceeded) {
    parentDiv.find('.purchase-count-message').html('You can only upload a maximum of ' + maxFiles + ' files.');
    parentDiv.find('.add-purchase').addClass('d-none');
    parentDiv.find('.book-item').addClass('d-none');
    parentDiv.find('#add-purchase-responsive').addClass('d-none');
    return;
  }

  parentDiv.find('.purchase-count-message').text('');
  parentDiv.find('.add-purchase').removeClass('d-none');
  parentDiv.find('.book-item').removeClass('d-none');
  parentDiv.find('#add-purchase-responsive').removeClass('d-none');

  if (!hasFiles) {
    parentDiv.find('.product-photo').addClass('d-none');
  }
}

function readImageFile(file) {
  return new Promise(function(resolve) {
    var reader = new FileReader();
    reader.onload = function(e) { resolve(e.target.result); };
    reader.onerror = function() { resolve(null); };
    reader.readAsDataURL(file);
  });
}

function cleanupProductGalleryBackdrops() {
  if ($('.modal.show').length > 0) {
    $('body').addClass('modal-open');
    return;
  }

  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open').css('padding-right', '');
}

function notifyProductImageDeleteError(message) {
  if (typeof toastr !== 'undefined') {
    toastr.error(message);
  } else {
    alert(message);
  }
}

function syncProductImageGalleryAfterDelete(modal) {
  var galleryModal = $(modal);
  var slides = galleryModal.find('.carousel-item');
  var imageCount = slides.length;
  var galleryId = galleryModal.attr('id');
  var trigger = $('[data-target="#' + galleryId + '"]');

  if (imageCount === 0) {
    trigger.remove();
    if (!galleryModal.hasClass('show')) {
      galleryModal.remove();
      cleanupProductGalleryBackdrops();
      return;
    }

    galleryModal.one('hidden.bs.modal', function() {
      galleryModal.remove();
      cleanupProductGalleryBackdrops();
    });
    galleryModal.modal('hide');
    return;
  }

  if (slides.filter('.active').length === 0) {
    slides.first().addClass('active');
  }

  slides.each(function(index) {
    var slide = $(this);
    var position = slide.find('.product-image-gallery-position');
    if (imageCount > 1) {
      if (position.length === 0) {
        position = $('<span class="product-image-gallery-position"></span>').appendTo(slide);
      }
      position.text((index + 1) + ' / ' + imageCount);
    } else {
      position.remove();
    }
  });

  var title = galleryModal.find('.product-image-gallery-title');
  var titlePrefix = title.text().replace(/\s*\(\d+\)\s*$/, '') || 'Product Images';
  var firstImageSrc = slides.first().find('.product-image-gallery-preview').attr('src');
  var countBadge = trigger.find('.product-image-gallery-count');

  title.text(titlePrefix + ' (' + imageCount + ')');
  trigger.find('.product-image-gallery-cover').attr('src', firstImageSrc);

  if (imageCount > 1) {
    if (countBadge.length === 0) {
      countBadge = $('<span class="product-image-gallery-count"></span>').appendTo(trigger);
    }
    countBadge.text('x' + imageCount);
  } else {
    countBadge.remove();
  }

  galleryModal.find('.product-image-gallery-control').toggleClass('d-none', imageCount <= 1);
  galleryModal.find('.carousel').carousel(0);
}

function removeProductImageFromGallery(galleryModal, imageId, productId) {
  var slidesToRemove = galleryModal.find('.carousel-item').filter(function() {
    var slide = $(this);
    var slideImageId = slide.attr('data-image-id') || slide.data('imageId');
    var slideProductId = slide.attr('data-product-id') || slide.data('productId');
    var sameImage = String(slideImageId) === String(imageId);
    var sameProduct = !productId || String(slideProductId) === String(productId);
    return sameImage && sameProduct;
  });

  if (slidesToRemove.length === 0) {
    return;
  }

  var activeSlide = slidesToRemove.filter('.active').first();
  var activateNext = activeSlide.length ? activeSlide.next('.carousel-item') : $();

  if (activateNext.length === 0 && activeSlide.length) {
    activateNext = activeSlide.prev('.carousel-item');
  }

  slidesToRemove.remove();
  activateNext.addClass('active');
  syncProductImageGalleryAfterDelete(galleryModal);
}

function removeProductImageFromMatchingGalleries(imageId, productId) {
  $('.product-image-gallery-modal').each(function() {
    removeProductImageFromGallery($(this), imageId, productId);
  });
}

$(document).on('show.bs.modal', '.product-image-gallery-modal', function() {
  if (this.parentNode !== document.body) {
    document.body.appendChild(this);
  }
});

$(document).on('hidden.bs.modal', '.product-image-gallery-modal', cleanupProductGalleryBackdrops);

$(document).on('click', '.js-persisted-product-image-remove', function(event) {
  event.preventDefault();
  event.stopPropagation();

  var button = $(this);
  var deleteUrl = button.data('url');

  if (!deleteUrl || button.data('deleting')) {
    return;
  }

  button.data('deleting', true).prop('disabled', true);

  $.ajax({
    url: deleteUrl,
    type: 'DELETE',
    dataType: 'json',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
  }).done(function() {
    var slide = button.closest('.carousel-item');
    var imageId = button.attr('data-image-id') || button.data('imageId');
    var productId = slide.attr('data-product-id') || slide.data('productId');
    removeProductImageFromMatchingGalleries(imageId, productId);
  }).fail(function(xhr) {
    var errorMessage = (xhr.responseJSON && xhr.responseJSON.error) || 'Image could not be deleted.';
    notifyProductImageDeleteError(errorMessage);
    button.prop('disabled', false);
  }).always(function() {
    button.data('deleting', false);
  });
});

window.renderCompactProductUploadPreview = function(input, options) {
  options = options || {};
  var maxFiles = options.maxFiles || 6;
  var openAfterRender = options.openAfterRender;
  var parentDiv = $(input).closest('.file-image-field');
  var previewContainer = parentDiv.find('.product-photo');
  var files = Array.from(input.files || []);

  previewContainer.empty().removeClass('d-none');

  if (files.length > maxFiles) {
    setPurchaseUploadControls(parentDiv, false, true, maxFiles);
    return;
  }

  var validFiles = files.filter(function(file) {
    return file.type && file.type.startsWith('image/');
  });

  if (validFiles.length !== files.length) {
    alert('Please upload only images.');
    setFilesOnInput(input, validFiles);
  }

  files = validFiles;
  setPurchaseUploadControls(parentDiv, files.length > 0, false, maxFiles);

  if (files.length === 0) {
    return;
  }

  var galleryId = $(input).data('upload-gallery-id');
  if (!galleryId) {
    galleryId = 'product-upload-gallery-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    $(input).data('upload-gallery-id', galleryId);
  }

  var renderToken = Date.now() + '-' + Math.random();
  $(input).data('upload-gallery-token', renderToken);

  Promise.all(files.map(readImageFile)).then(function(imageSources) {
    if ($(input).data('upload-gallery-token') !== renderToken) {
      return;
    }

    var usableImages = imageSources.map(function(src, index) {
      return { src: src, index: index };
    }).filter(function(item) {
      return item.src;
    });

    if (usableImages.length === 0) {
      previewContainer.addClass('d-none');
      return;
    }

    var imageCount = usableImages.length;
    var modalTarget = '#' + galleryId;
    var coverHtml = [
      '<button type="button" class="product-image-gallery-thumb border-0 bg-transparent p-0 ml-1" data-toggle="modal" data-target="' + modalTarget + '" aria-label="Product image ' + imageCount + '">',
        '<img src="' + usableImages[0].src + '" class="product-image-gallery-cover" alt="Product image 1">',
        imageCount > 1 ? '<span class="product-image-gallery-count">x' + imageCount + '</span>' : '',
      '</button>'
    ].join('');

    var slidesHtml = usableImages.map(function(item, displayIndex) {
      return [
        '<div class="carousel-item ' + (displayIndex === 0 ? 'active' : '') + '">',
          '<img src="' + item.src + '" class="product-image-gallery-preview" alt="Product image ' + (displayIndex + 1) + '">',
          imageCount > 1 ? '<span class="product-image-gallery-position">' + (displayIndex + 1) + ' / ' + imageCount + '</span>' : '',
          '<button type="button" class="product-image-gallery-remove js-upload-gallery-remove" data-index="' + item.index + '" aria-label="Remove image">',
            '<i class="fas fa-trash"></i>',
          '</button>',
        '</div>'
      ].join('');
    }).join('');

    var controlsHtml = imageCount > 1 ? [
      '<a class="carousel-control-prev product-image-gallery-control" href="#' + galleryId + '-carousel" role="button" data-slide="prev" aria-label="Previous">',
        '<span class="carousel-control-prev-icon" aria-hidden="true"></span>',
      '</a>',
      '<a class="carousel-control-next product-image-gallery-control" href="#' + galleryId + '-carousel" role="button" data-slide="next" aria-label="Next">',
        '<span class="carousel-control-next-icon" aria-hidden="true"></span>',
      '</a>'
    ].join('') : '';

    var modalHtml = [
      '<div class="modal fade product-image-gallery-modal" id="' + galleryId + '" tabindex="-1" role="dialog" aria-hidden="true">',
        '<div class="modal-dialog modal-dialog-centered" role="document">',
          '<div class="modal-content product-image-gallery-content">',
            '<div class="modal-header product-image-gallery-header">',
              '<span class="product-image-gallery-title">Product Images (' + imageCount + ')</span>',
              '<button type="button" class="close product-image-gallery-close p-0" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>',
            '</div>',
            '<div class="modal-body product-image-gallery-body">',
              '<div class="carousel slide" id="' + galleryId + '-carousel" data-ride="false" data-interval="false">',
                '<div class="carousel-inner">' + slidesHtml + '</div>',
                controlsHtml,
              '</div>',
            '</div>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    previewContainer.html(coverHtml);
    $(modalTarget).remove();
    $('body').append(modalHtml);
    var galleryModal = $(modalTarget);
    galleryModal.on('hidden.bs.modal', cleanupProductGalleryBackdrops);
    if (openAfterRender) {
      galleryModal.modal('show');
    }
    galleryModal.find('.js-upload-gallery-remove').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      var removeIndex = Number($(this).data('index'));
      var updatedFiles = Array.from(input.files || []);
      if (!Number.isNaN(removeIndex) && removeIndex >= 0) {
        updatedFiles.splice(removeIndex, 1);
      }
      setFilesOnInput(input, updatedFiles);
      galleryModal.one('hidden.bs.modal', function() {
        galleryModal.remove();
        window.renderCompactProductUploadPreview(input, $.extend({}, options, { openAfterRender: updatedFiles.length > 0 }));
      });
      galleryModal.modal('hide');
    });
  });
}

window.packageImages = function(input, event) {
  var fileLength = input.files.length;
  var maxFiles = 4;
  var parentDiv = $(input).closest('.file-image-field');
  var previewContainerWrapper = parentDiv.find(".product-photo");
  previewContainerWrapper.empty().removeClass("d-none");

  if (fileLength > maxFiles) {
    toastr.error('You can upload a maximum of ' + maxFiles + ' images only.');
    parentDiv.find('.add-purchase').addClass('d-none');
    parentDiv.find('.book-item').addClass('d-none');
    parentDiv.find("#add-purchase-responsive").addClass("d-none");
    return;
  }

  parentDiv.find('.purchase-count-message').text('');
  parentDiv.find('.add-purchase').removeClass('d-none');
  parentDiv.find('.book-item').removeClass('d-none');
  parentDiv.find("#add-purchase-responsive").removeClass("d-none");

  var $btn = parentDiv.find('.package-image-btn');
  $btn.addClass('d-none');

  var files = Array.from(input.files);
  var validFiles = [];

  files.forEach(function(file, index) {
    var ext = (file.name || '').split('.').pop().toLowerCase();
    var isImg = file.type.startsWith('image/') ||
      ['jpg','jpeg','png','gif','bmp','webp','heic','heif','tiff','tif','avif','jfif','raw','dng','cr2','nef','arw'].includes(ext);

    if (!isImg) {
      alert('Please upload only images.');
      return;
    }

    validFiles.push(file);

    var reader = new FileReader();
    reader.onload = function(e) {
      var imgElement = $('<img>', {
        src: e.target.result,
        class: 'product-img-prev',
        width: '123px',
        style: 'margin-right: 5px;',
        'data-index': index
      });
      var removeIcon = $('<div>', {
        class: 'remove-icon d-flex justify-content-center align-items-center remove-image',
        text: '×',
        'data-index': index,
        click: function() {
          removeEditImage(this, input, parentDiv);
        }
      });
      previewContainerWrapper.append($('<div>', { class: 'position-relative', append: [imgElement, removeIcon] }));
    };
    reader.readAsDataURL(file);
  });

  if (validFiles.length === 0) return;

  Promise.all(validFiles.map(function(file) {
    return compressImageFile(file);
  })).then(function(compressedFiles) {
    var dt = new DataTransfer();
    compressedFiles.forEach(function(f) { dt.items.add(f); });
    input.files = dt.files;
    $btn.removeClass('d-none').prop('disabled', false);
  }).catch(function() {
    $btn.removeClass('d-none').prop('disabled', false);
  });
}

window.advanceProofImages = function(input) {
  const fileLength = input.files.length;
  const maxFiles = 6;
  const parentDiv = $(input).closest('.file-image-field');
  const previewContainerWrapper = parentDiv.find('.product-photo');
  previewContainerWrapper.empty().removeClass('d-none');

  if (fileLength > maxFiles) {
    toastr.error('You can upload a maximum of ' + maxFiles + ' images only.');
    return;
  }

  $.each(input.files, function(index, file) {
    if (!file.type.startsWith('image/')) {
      toastr.error('Please upload images only.');
      return;
    }
    const reader = new FileReader();
    reader.onload = function(e) {
      const imgElement = $('<img>', {
        src: e.target.result,
        class: 'product-img-prev',
        width: '32px',
        height: '32px',
        style: 'margin-right: 5px; object-fit: cover; border-radius: 4px;',
        'data-index': index
      });
      const removeIcon = $('<div>', {
        class: 'remove-icon d-flex justify-content-center align-items-center',
        text: '×',
        click: function() {
          $(this).closest('.position-relative').remove();
          if (previewContainerWrapper.children('.position-relative').length === 0) {
            parentDiv.find('.advance-proof-btn').addClass('d-none');
          }
        }
      });
      const previewItem = $('<div>', { class: 'position-relative', style: 'display: inline-block;' });
      previewItem.append(imgElement).append(removeIcon);
      previewContainerWrapper.append(previewItem);
    };
    reader.readAsDataURL(file);
  });
  if (fileLength > 0) {
    parentDiv.find('.advance-proof-btn').removeClass('d-none');
  }
}

function removeEditImage(removeIcon, input, parentDiv) {
  const previewItem = $(removeIcon).closest('.position-relative, .image-preview-container');
  const currentParentDiv = parentDiv || $(removeIcon).closest('.file-image-field');
  const currentInput = input || currentParentDiv.find('input[type="file"]').first()[0];
  const fileIndex = Number($(removeIcon).data('index'));
  const dataTransfer = new DataTransfer();
  const files = currentInput ? Array.from(currentInput.files) : [];
  if (!Number.isNaN(fileIndex) && fileIndex >= 0) {
    files.splice(fileIndex, 1);
  }
  files.forEach(file => {
    dataTransfer.items.add(file);
  });

  if (currentInput) {
    currentInput.files = dataTransfer.files;
  }

  previewItem.remove();
  currentParentDiv.find('.product-photo .remove-image').each(function(index) {
    $(this).attr('data-index', index).data('index', index);
    $(this).siblings('img').attr('data-index', index);
  });
}

$(document).on('click', '.biometric-tab', function() {
  toastr.remove();
  toastr.error("Biometric authentication is not available in this version.");
  return false;
})

$(document).on('click', '.biometric-tab-upload-card', function() {
  toastr.remove();
  toastr.error("Please wait until admin approved your documents.");
  return false;
})

function isValidPhone(phone) {
  var pattern = /^\+?[0-9\s\-\(\)]{7,20}$/;
  return pattern.test(phone);
}
$(document).on('input','#phone', function(){
  var phone = $(this).val();
  if (!isValidPhone(phone)) {
    $('#phone-error').show();
    $(this).addClass('is-invalid');
  } else {
    $('#phone-error').hide();
    $(this).removeClass('is-invalid');
  }
});

function initDropdowns() {
  $('.dropdown-toggle').dropdown();
}

$(document).on("click", ".resend-link", function (e) {
  $.ajax({
      url: "/users/profile/resend_otp",
      type: "POST",
      dataType: "json",
      data: {
      mobile: $("#mobile").val(),     
      user_role: $("#profile_type").val(),
      country_code: $("#country_code").val(),                 
      id: $("#user_id").val()
      },
      success: function (response) {
          if (response.info) {
              toastr.success(response.info)
          }
          if (response.error) {
              toastr.error(response.error)
          }
      },
      error: function (xhr) {
          alert("Something went wrong. Please try again!");
      }
  });
});

// $(document).on('click','#sidebarToggle', function () {
//   $('#sidebar').toggleClass('collapsed');
//   $('#mainContent').toggleClass('collapsed');
// });
$(document).ready(function () {
  function handleSidebarCollapse(e) {
    if (e.matches) {
      $('#sidebar, #mainContent').addClass('collapsed');
    } else {
      $('#sidebar, #mainContent').removeClass('collapsed');
    }
  }
  var mediaQuery = window.matchMedia("(max-width: 768px)");


  handleSidebarCollapse(mediaQuery);

  mediaQuery.addListener(handleSidebarCollapse);
  
  $(document).on('click', '#sidebarToggle', function () {
    $('#sidebar, #mainContent').toggleClass('collapsed');
  });
});

$(document).on('click',".rotate", function () {
  $(this).toggleClass("down");
})

function trimToWordLimit(value, maxWords) {
  if (!value) return value;

  var words = value.match(/\S+/g) || [];
  if (words.length <= maxWords) return value;

  var wordPattern = /\S+/g;
  var wordCount = 0;
  var match;
  var endIndex = value.length;

  while ((match = wordPattern.exec(value)) !== null) {
    wordCount += 1;
    if (wordCount === maxWords) {
      endIndex = wordPattern.lastIndex;
      break;
    }
  }

  return value.slice(0, endIndex);
}

function wordCount(value) {
  var words = (value || '').match(/\S+/g);
  return words ? words.length : 0;
}

function valueWithInsertedText(field, text) {
  var value = field.value || '';
  var start = field.selectionStart;
  var end = field.selectionEnd;

  if (typeof start !== 'number' || typeof end !== 'number') {
    return value + text;
  }

  return value.slice(0, start) + text + value.slice(end);
}

function maxWordsMessage($field, maxWords) {
  return $field.data('max-words-message') || ('Only ' + maxWords + ' words are allowed.');
}

function maxCharsMessage($field, maxChars) {
  return $field.data('max-chars-message') || ('Only ' + maxChars + ' characters are allowed.');
}

function showLimitError(field, message) {
  var $field = $(field);
  var $error = $field.next('.field-limit-error');

  if (!$error.length) {
    $error = $('<small class="field-limit-error text-danger d-block mt-1"></small>');
    $field.after($error);
  }

  $field.addClass('is-invalid');
  $error.text(message);
}

function showMaxWordsError(field, maxWords) {
  showLimitError(field, maxWordsMessage($(field), maxWords));
}

function showMaxCharsError(field, maxChars) {
  showLimitError(field, maxCharsMessage($(field), maxChars));
}

function clearLimitError(field) {
  var $field = $(field);
  $field.removeClass('is-invalid');
  $field.next('.field-limit-error').remove();
}

function refreshFieldLimitState(field) {
  var maxChars = parseInt($(field).data('max-chars'), 10);
  var maxWords = parseInt($(field).data('max-words'), 10);

  if (maxChars && (field.value || '').length > maxChars) {
    showMaxCharsError(field, maxChars);
    return;
  }

  if (wordCount(field.value) > maxWords) {
    showMaxWordsError(field, maxWords);
  } else {
    clearLimitError(field);
  }
}

function trimToCharLimit(value, maxChars) {
  if (!maxChars || !value || value.length <= maxChars) return value;
  return value.slice(0, maxChars);
}

$(document).on('beforeinput', '[data-max-chars]', function(event) {
  var originalEvent = event.originalEvent;
  var maxChars = parseInt($(this).data('max-chars'), 10);
  if (!maxChars || !originalEvent || !originalEvent.inputType || !/^insert/.test(originalEvent.inputType)) return;
  if (originalEvent.inputType === 'insertCompositionText') return;

  var insertedText = originalEvent.data || '';
  if (!insertedText) return;

  if (valueWithInsertedText(this, insertedText).length > maxChars) {
    event.preventDefault();
    showMaxCharsError(this, maxChars);
  }
});

$(document).on('paste', '[data-max-chars]', function(event) {
  var maxChars = parseInt($(this).data('max-chars'), 10);
  if (!maxChars) return;

  var clipboardData = event.originalEvent && event.originalEvent.clipboardData;
  var pastedText = clipboardData ? clipboardData.getData('text') : '';
  if (!pastedText) return;

  if (valueWithInsertedText(this, pastedText).length > maxChars) {
    event.preventDefault();
    showMaxCharsError(this, maxChars);
  }
});

$(document).on('beforeinput', '[data-max-words]', function(event) {
  var originalEvent = event.originalEvent;
  var maxWords = parseInt($(this).data('max-words'), 10);
  if (!maxWords || !originalEvent || !originalEvent.inputType || !/^insert/.test(originalEvent.inputType)) return;
  if (originalEvent.inputType === 'insertCompositionText') return;

  var insertedText = originalEvent.data || '';
  if (!insertedText) return;

  if (wordCount(valueWithInsertedText(this, insertedText)) > maxWords) {
    event.preventDefault();
    showMaxWordsError(this, maxWords);
  }
});

$(document).on('paste', '[data-max-words]', function(event) {
  var maxWords = parseInt($(this).data('max-words'), 10);
  if (!maxWords) return;

  var clipboardData = event.originalEvent && event.originalEvent.clipboardData;
  var pastedText = clipboardData ? clipboardData.getData('text') : '';
  if (!pastedText) return;

  if (wordCount(valueWithInsertedText(this, pastedText)) > maxWords) {
    event.preventDefault();
    showMaxWordsError(this, maxWords);
  }
});

$(document).on('input', '[data-max-words]', function() {
  var $field = $(this);
  var maxWords = parseInt($field.data('max-words'), 10);
  if (!maxWords) return;

  var trimmedValue = trimToWordLimit($field.val(), maxWords);
  if (trimmedValue === $field.val()) {
    refreshFieldLimitState(this);
    return;
  }

  $field.val(trimmedValue);
  refreshFieldLimitState(this);
});

$(document).on('input', '[data-max-chars]', function() {
  var $field = $(this);
  var maxChars = parseInt($field.data('max-chars'), 10);
  if (!maxChars) return;

  var trimmedValue = trimToCharLimit($field.val(), maxChars);
  if (trimmedValue === $field.val()) {
    refreshFieldLimitState(this);
    return;
  }

  $field.val(trimmedValue);
  refreshFieldLimitState(this);
});

function initFieldLimitFields(context) {
  $(context || document).find('[data-max-words], [data-max-chars]').each(function() {
    refreshFieldLimitState(this);
  });
}

$(document).on('turbolinks:load shown.bs.modal ajaxComplete', function(event) {
  initFieldLimitFields(event.target);
});

// Share Modal — copyToClipboard moved from _share_modal partial
window.copyToClipboard = function(tripId) {
  var copyText = document.getElementById('hiddenShareLink-' + tripId).value;
  var copylink = document.getElementById('shareLink-' + tripId);
  if (copylink) copylink.select();
  navigator.clipboard.writeText(copyText)
    .then(function() {})
    .catch(function(err) { console.error('Failed to copy:', err); });
};
